import { Panel, Eyebrow } from "@/components/mh/bits";

const Chips = ({ items }) => (
  <div className="flex flex-wrap gap-1.5 mt-2">
    {(items || []).map((x) => <span key={x} className="px-2 py-1 rounded-md border border-white/10 bg-white/[0.02] text-xs">{x}</span>)}
  </div>
);

const List = ({ items, hex }) => (
  <ul className="mt-2 space-y-2">
    {(items || []).map((x) => <li key={x} className="text-sm flex gap-2.5"><span className="mt-2 w-1 h-1 rounded-full flex-shrink-0" style={{ background: hex }} />{x}</li>)}
  </ul>
);

export const Block = ({ title, children, cls }) => (
  <Panel cls={`p-5 ${cls || ""}`}><Eyebrow>{title}</Eyebrow>{children}</Panel>
);

export const AgentOverview = ({ a, hex }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
    <Block title="What it does" cls="lg:col-span-2">
      <p className="text-base mt-2">{a.what_it_does?.plain}</p>
      <p className="text-sm text-muted-foreground mt-2">{a.what_it_does?.technical}</p>
    </Block>
    <Block title="Inputs"><Chips items={a.inputs_outputs?.inputs} /></Block>
    <Block title="Outputs"><Chips items={a.inputs_outputs?.outputs} /><Eyebrow cls="mt-4">Formats</Eyebrow><Chips items={a.inputs_outputs?.formats} /></Block>
    <Block title="Integrations"><Chips items={a.integrations} /></Block>
    <Block title="Replaces"><Chips items={a.tools_replaced} /></Block>
    <Block title="KPIs it moves"><List items={a.kpis} hex={hex} /></Block>
    <Block title="Model recommendations">
      <div className="mt-2 space-y-2 text-sm">
        {Object.entries(a.model_recommendations || {}).map(([k, v]) => (
          <div key={k}><span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground mr-2">{k.replace("_", " ")}</span>{v}</div>
        ))}
      </div>
    </Block>
  </div>
);

export const AgentGuardrails = ({ a, hex }) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
    <Block title="Guardrails"><List items={a.guardrails} hex="#D4FF3A" /></Block>
    <Block title="Human checkpoints"><List items={a.hitl_checkpoints} hex="#FFB020" /></Block>
    <Block title="Failure modes"><List items={a.failure_modes} hex="#FF3B5C" /></Block>
  </div>
);

const LADDER = [["human_led", "Human-led"], ["human_assisted", "Human-assisted"], ["fully_autonomous", "Fully autonomous"]];

export const AgentLadder = ({ a, hex }) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-testid="agent-ladder">
    {LADDER.map(([k, label], i) => {
      const r = a.the_ladder?.[k];
      if (!r) return null;
      const extra = r.when_to_upgrade || r.kpi_when_it_works;
      return (
        <Panel key={k} cls="p-5" style={a.autonomy === label ? { borderColor: hex } : undefined}>
          <div className="flex justify-between items-center"><Eyebrow>Rung 0{i + 1} · {label}</Eyebrow>{a.autonomy === label && <span className="font-mono text-[10px]" style={{ color: hex }}>DESIGNED FOR</span>}</div>
          <h4 className="font-display text-xl mt-2">{r.headline}</h4>
          <p className="text-xs text-muted-foreground mt-1">{r.who}</p>
          <ol className="mt-3 space-y-1.5">{(r.flow || []).map((s, j) => <li key={j} className="text-sm flex gap-2"><span className="font-mono text-[10px] text-muted-foreground mt-0.5">{j + 1}</span>{s}</li>)}</ol>
          {(r.catch || r.gate) && <p className="text-sm mt-3 text-muted-foreground italic">{r.catch || r.gate}</p>}
          {extra && <p className="text-xs mt-3 font-mono" style={{ color: hex }}>{extra}</p>}
        </Panel>
      );
    })}
  </div>
);
